import React from "react";
import { useNavigate } from "react-router-dom";
import { GoogleLoginResponse, useGoogleLogin } from "@leecheuk/react-google-login";
import { Button, Typography } from "@mui/material";
import GoogleIcon from "assets/images/icons/google.svg";
import Config from "configs/Config";
import UserStore from "stores/UserStore";

import I18n from "../I18n";

import * as styles from "./styles";

export default function GoogleLoginButton(props: { isOnLandingPage: boolean }) {
	const navigate = useNavigate();
	const config = Config.getInstance();
	const userStore = UserStore.getInstance();

	const { signIn } = useGoogleLogin({
		clientId: config.get().googleOauth.web.client_id,
		cookiePolicy: "single_host_origin",
		onSuccess: async (response) => {
			const res = response as GoogleLoginResponse;
			const oAuthToken = res.tokenObj.id_token;
			await userStore.signInOAuth(oAuthToken);
			navigate("/dashboards");
		},
	});

	return <LoginButton signIn={signIn} isOnLandingPage={props.isOnLandingPage} />;
}

type IProps = {
	signIn: () => void;
	isOnLandingPage: boolean;
};
type IState = Record<string, never>;

class LoginButton extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);
	}

	public override render(): React.ReactNode {
		return (
			<Button sx={styles.googleButton} variant="outlined" onClick={this.props.signIn}>
				<img src={GoogleIcon} style={{ width: "20px" }} />
				<Typography variant="body2" ml={2}>
					{this.props.isOnLandingPage ? (
						<I18n map={"pages.home.login_google_button"} />
					) : (
						<I18n map={"components.home_top_bar.login_google_button"} />
					)}
				</Typography>
			</Button>
		);
	}
}
